import uz from "./uz.json";
import ru from "./ru.json";

export const defaultLocale = "uz";

export const languages = { uz, ru };
